import { getLocalTimeZone, today } from "@internationalized/date"
import { useQueryClient, useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { Button } from "@/globalComponents/atoms/Button"
import Card from "@/globalComponents/atoms/Card"
import Heading from "@/globalComponents/atoms/Heading"
import ExpandableText from "@/globalComponents/molecules/ExpandableText"
import AccessKeyCallout from "@/routes/qr/$qrLookupID/reserve.$epoch/-components/AccessKeyCallout"
import {
  applyAccessCodeMutationOptions,
  calendarsQueryOptions,
} from "@/utilities/hooks/queries/reserve"
import { useTheme } from "@/utilities/hooks/useTheme"

import styles from "./index.module.css"

export const Route = createFileRoute(
  "/qr/$qrLookupID/reserve/$epoch/calendars/"
)({
  staticData: {
    pageName: "Available Parking",
  },
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { t } = useTranslation("reserve")
  const { scannedArea } = useTheme()
  const timezoneLocation = scannedArea!.theme.locationInformation.timeZone
  const locationID = scannedArea!.theme.locationInformation.locationID
  const queryClient = useQueryClient()
  const { data: calendars } = useSuspenseQuery(
    calendarsQueryOptions({ locationID })
  )

  return (
    <>
      <Heading level={1} as={1} className="center">
        {t("calendars.heading")}
      </Heading>
      <div className={styles.calloutSection}>
        <AccessKeyCallout
          mutationOptions={applyAccessCodeMutationOptions(queryClient, locationID)}
        />
      </div>
      <div className={styles.calendarList}>
        {calendars.map((calendar) => (
          <Card key={calendar.bookingCalendarID}>
            <Heading level={2}>{calendar.metadata.header}</Heading>
            <ExpandableText>{calendar.metadata.description}</ExpandableText>
            <Button
              buttonType="primary"
              onPress={() => {
                const t = today(timezoneLocation || getLocalTimeZone())
                navigate({
                  to: "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month",
                  params: {
                    calendarID: calendar.bookingCalendarID,
                    year: String(t.year),
                    month: String(t.month).padStart(2, "0"),
                  },
                })
              }}
            >
              {t("calendars.select")}
            </Button>
          </Card>
        ))}
      </div>
    </>
  )
}
